<template>
    <div class="l-element">
        <heading-form-label text="学年" label="required"/>
        <div class="is-mgb8">
            <form-select
                placeholder="学年"
                selectName="grade"
                :optionList="gradeList"
                v-model="grade"
                :value="gradeValue"
            />
        </div>
        <p v-if="errorText" class="m-text-comments is-caution" data-jest="error-text-grade">{{ errorText }}</p>
    </div>
</template>

<script>
import HeadingFormLabel from "../atoms/HeadingFormLabel.vue";
import FormSelect from "../atoms/FormSelect.vue";
import {SchoolGradeUtil} from "../../util/SchoolGradeUtil";

export default ({
    name: "InputProfileItemGrade",
    components: {
        HeadingFormLabel,
        FormSelect
    },
    data() {
        return {
            gradeList: SchoolGradeUtil.getGradeList(),
        }
    },
    props: {
        gradeValue: {
            type: String,
            required: true
        },
        /**
         * エラー文言
         */
        errorText: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: ['input'],
    computed: {
        grade: {
            get() {
                return this.gradeValue
            },
            set(value) {
                this.$emit("input", value);
            }
        }
    }
})

</script>
